import { styled } from '@material-ui/core';

export const SdmStack = styled('div')(
  ({
    spacing = 0,
    direction = 'column',
    theme,
    justifyContent,
    justifyItems,
    alignContent,
    alignItems,
  }) => ({
    gap: theme.spacing(spacing),
    flexDirection: direction,
    display: 'flex',
    justifyContent,
    justifyItems,
    alignContent,
    alignItems,
  })
);
